import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import SavedAddress, {
  CreateSavedAddressPayload,
  UpdateSavedAddressPayload,
} from "@mapmycustomers/shared/types/SavedAddress";
import { OptionalFields } from "@mapmycustomers/shared/util/ts";

import {
  SavedLocationCreateSource,
  SavedLocationDeleteSurface,
} from "@app/util/analytic/savedLocationsAnalytics";

interface SavedAddressWriteRequest<T> {
  callback?: (savedAddress: SavedAddress) => void;
  failureCallback?: (error: unknown) => void;
  payload: T;
}

export const fetchSavedAddresses = createAsyncAction(
  "@savedLocations/fetchSavedAddresses/request",
  "@savedLocations/fetchSavedAddresses/success",
  "@savedLocations/fetchSavedAddresses/failure"
)<void, { limit: number; savedAddresses: SavedAddress[] }, unknown>();

// Without a geoPoint the saga geocodes the address first
export const createSavedAddress = createAsyncAction(
  "@savedLocations/createSavedAddress/request",
  "@savedLocations/createSavedAddress/success",
  "@savedLocations/createSavedAddress/failure"
)<
  SavedAddressWriteRequest<OptionalFields<CreateSavedAddressPayload, "geoPoint">> & {
    hideLimitNotification?: true; // the caller shows the limit itself
    source: SavedLocationCreateSource;
  },
  SavedAddress,
  unknown
>();

export const updateSavedAddress = createAsyncAction(
  "@savedLocations/updateSavedAddress/request",
  "@savedLocations/updateSavedAddress/success",
  "@savedLocations/updateSavedAddress/failure"
)<
  SavedAddressWriteRequest<UpdateSavedAddressPayload>,
  { replaceId?: SavedAddress["id"]; savedAddress: SavedAddress },
  unknown
>();

export const deleteSavedAddress = createAsyncAction(
  "@savedLocations/deleteSavedAddress/request",
  "@savedLocations/deleteSavedAddress/success",
  "@savedLocations/deleteSavedAddress/failure"
)<
  {
    callback?: () => void;
    failureCallback?: (error: unknown) => void;
    id: SavedAddress["id"];
    surface?: SavedLocationDeleteSurface;
  },
  SavedAddress["id"],
  unknown
>();

export const markSavedAddressUsed = createAsyncAction(
  "@savedLocations/markSavedAddressUsed/request",
  "@savedLocations/markSavedAddressUsed/success",
  "@savedLocations/markSavedAddressUsed/failure"
)<SavedAddress["id"], { id: SavedAddress["id"]; lastUsedAt: string }, unknown>();

export const resetSavedAddresses = createAction("@savedLocations/resetSavedAddresses")();

export type Actions = ActionType<
  | typeof createSavedAddress
  | typeof deleteSavedAddress
  | typeof fetchSavedAddresses
  | typeof markSavedAddressUsed
  | typeof resetSavedAddresses
  | typeof updateSavedAddress
>;
